import * as Toggle from '@radix-ui/react-toggle-group'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React, { ReactNode } from 'react'
import styled from 'styled-components'

const StyledToggleItem = styled(Toggle.Item)<{ $selected: boolean }>`
  cursor: ${({ $selected }) => ($selected ? 'auto' : 'pointer')} !important;
  background-color: ${({ theme, $selected }) =>
    $selected
      ? theme.forecast.background4
      : theme.forecast.background1} !important;
  opacity: 0.8 !important;
  padding: 8px !important;
  height: 28px !important;
  width: 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  &:hover {
    opacity: ${({ $selected }) => ($selected ? 0.8 : 1)} !important;
    background-color: ${({ theme, $selected }) =>
      $selected
        ? theme.forecast.background4
        : theme.forecast.background3} !important;
  }
`

export const KestrelViewerTool: React.FC<{
  modeId: string
  tooltipLabel: string
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left'
  selectedMode: string
  children: ReactNode
  onClick?: () => void
  measurementTypeId?: string
}> = ({
  modeId,
  tooltipLabel,
  tooltipSide = 'right',
  selectedMode,
  children,
  onClick,
  measurementTypeId,
}) => {
  const { measurementType } = useKestrelViewerContext()

  const isSelected =
    selectedMode === modeId &&
    (!measurementTypeId || measurementTypeId === measurementType)

  return (
    <TooltipWrapper side={tooltipSide} offset={5} label={tooltipLabel}>
      <StyledToggleItem value={modeId} $selected={isSelected} onClick={onClick}>
        {children}
      </StyledToggleItem>
    </TooltipWrapper>
  )
}
